$(function(){
  $('.js-secSlideImgs').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $('.js-btnAcc').next().hide(0);
  $('.js-btnAcc').click(function() {
    $(this).next().slideToggle();
    $(this).toggleClass("is-open");
  });

  let lastScroll = $(window).scrollTop();
  let isHidden = true;
  let isScrollingByAnchor = false;
  const target = $('.js-fixedArea');

  // 初期表示の制御
  if (lastScroll <= 100) {
    target.show();
    isHidden = false;
  }

  $(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();
    const windowHeight = $(this).height();
    const documentHeight = $(document).height();
    const isAtBottom = currentScroll + windowHeight >= documentHeight - 20;

    // アンカースクロール中は常に非表示にする
    if (isScrollingByAnchor) {
      if (!isHidden) {
        target.stop(true, true).fadeOut('fast');
        isHidden = true;
      }
      return;
    }

    if (isAtBottom) {
      if (!isHidden) {
        target.stop(true, true).fadeOut('fast');
        isHidden = true;
      }
      return;
    }

    if (currentScroll <= 100) {
      if (isHidden) {
        target.stop(true, true).fadeIn('fast');
        isHidden = false;
      }
    } else if (currentScroll > lastScroll) {
      if (!isHidden) {
        target.stop(true, true).fadeOut('fast');
        isHidden = true;
      }
    } else {
      if (isHidden) {
        target.stop(true, true).fadeIn('fast');
        isHidden = false;
      }
    }

    lastScroll = currentScroll;
  });

  $('a[href^="#"]').on('click', function (event) {
    const anchorTarget = $(this.getAttribute('href'));
    if (anchorTarget.length) {
      event.preventDefault();

      isScrollingByAnchor = true;
      target.stop(true, true).fadeOut('fast');
      isHidden = true;

      $('html, body').animate({
        scrollTop: anchorTarget.offset().top
      }, 500, function () {
        // スクロール完了後、100ms待ってからスクロール監視を再開
        setTimeout(() => {
          isScrollingByAnchor = false;
          lastScroll = $(window).scrollTop(); // スクロール位置をリセット
        }, 100);
      });
    }
  });
});

function checkBreakPoint() {
	if (window.matchMedia("(max-width:859px)").matches) {
		$('.js-secFlowBox2Slide').not('.slick-initialized').slick({
			autoplay: true,
      dots: true,
      swipe: false,
      arrows: false,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      centerMode:true,
      centerPadding:"19%",
      speed: 1500,
      autoplaySpeed: 5000,
		});
	} else {
		$('.js-secFlowBox2Slide.slick-initialized').slick('unslick');
	}
}
$(window).resize(function(){
	checkBreakPoint();
});
checkBreakPoint();

